import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/fishing.svg'
import _imports_1 from '@/assets/svg/cargo.svg'
import _imports_2 from '@/assets/svg/tanker.svg'
import _imports_3 from '@/assets/svg/underwater.svg'
import _imports_4 from '@/assets/svg/diving.svg'
import _imports_5 from '@/assets/svg/passenger.svg'
import _imports_6 from '@/assets/svg/unknown.svg'
import _imports_7 from '@/assets/svg/other.svg'


const _hoisted_1 = ["id", "data-bs-parent"]
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = { class: "form-check" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = { class: "form-check" }

import { computed } from 'vue'
import { useFilterStore } from '@/stores/HomeFilterStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'Vesseltraffic',
  props: {
  accordionInnerId: {
    type: String,
    required: true
  },
  accordionOuterId: {
    type: String,
    required: true
  }
},
  setup(__props) {

const filterStore = useFilterStore()



const isFishingActive = computed({
  get() {
    return filterStore.isFishingActive
  },
  set() {
    filterStore.setFishing()
  }
})

const isCargoActive = computed({
  get() {
    return filterStore.isCargoActive
  },
  set() {
    filterStore.setCargo()
  }
})

const isTankerActive = computed({
  get() {
    return filterStore.isTankerActive
  },
  set() {
    filterStore.setTanker()
  }
})

const isUnderwaterActive = computed({
  get() {
    return filterStore.isUnderwaterActive
  },
  set() {
    filterStore.setUnderwater()
  }
})

const isDivingActive = computed({
  get() {
    return filterStore.isDivingActive
  },
  set() {
    filterStore.setDiving()
  }
})

const isPassengerActive = computed({
  get() {
    return filterStore.isPassengerActive
  },
  set() {
    filterStore.setPassenger()
  }
})

const isOtherActive = computed({
  get() {
    return filterStore.isOtherActive
  },
  set() {
    filterStore.setOther()
  }
})

const isUnknownActive = computed({
  get() {
    return filterStore.isUnknownActive
  },
  set() {
    filterStore.setUnknown()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.accordionInnerId,
    class: "accordion-collapse collapse accordion-border",
    "data-bs-parent": '#' + __props.accordionOuterId
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input me-3",
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isFishingActive).value = $event)),
          id: "flexCheckFishing"
        }, null, 512), [
          [_vModelCheckbox, isFishingActive.value]
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("img", {
          src: _imports_0,
          class: "icon mb-1 me-3"
        }, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("label", {
          class: "form-check-label NKT-P2",
          for: "flexCheckFishing"
        }, " Fishing ", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input me-3",
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isCargoActive).value = $event)),
          id: "flexCheckCargo"
        }, null, 512), [
          [_vModelCheckbox, isCargoActive.value]
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("img", {
          src: _imports_1,
          class: "icon mb-1 me-3"
        }, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          class: "form-check-label NKT-P2",
          for: "flexCheckCargo"
        }, " Cargo ", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input me-3",
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isTankerActive).value = $event)),
          id: "flexCheckTanker"
        }, null, 512), [
          [_vModelCheckbox, isTankerActive.value]
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("img", {
          src: _imports_2,
          class: "icon mb-1 me-3"
        }, null, -1)),
        _cache[13] || (_cache[13] = _createElementVNode("label", {
          class: "form-check-label NKT-P2",
          for: "flexCheckTanker"
        }, " Tanker ", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input me-3",
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isUnderwaterActive).value = $event)),
          id: "flexCheckUnderwater"
        }, null, 512), [
          [_vModelCheckbox, isUnderwaterActive.value]
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("img", {
          src: _imports_3,
          class: "icon mb-1 me-3"
        }, null, -1)),
        _cache[15] || (_cache[15] = _createElementVNode("label", {
          class: "form-check-label NKT-P2",
          for: "flexCheckUnderwater"
        }, " Underwater ", -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input me-3",
          type: "checkbox",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isDivingActive).value = $event)),
          id: "flexCheckDiving"
        }, null, 512), [
          [_vModelCheckbox, isDivingActive.value]
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("img", {
          src: _imports_4,
          class: "icon mb-1 me-3"
        }, null, -1)),
        _cache[17] || (_cache[17] = _createElementVNode("label", {
          class: "form-check-label NKT-P2",
          for: "flexCheckDiving"
        }, " Diving ", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input me-3",
          type: "checkbox",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isPassengerActive).value = $event)),
          id: "flexCheckPassenger"
        }, null, 512), [
          [_vModelCheckbox, isPassengerActive.value]
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("img", {
          src: _imports_5,
          class: "icon mb-1 me-3"
        }, null, -1)),
        _cache[19] || (_cache[19] = _createElementVNode("label", {
          class: "form-check-label NKT-P2",
          for: "flexCheckPassenger"
        }, " Passenger ", -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input me-3",
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isUnknownActive).value = $event)),
          id: "flexCheckUnknown"
        }, null, 512), [
          [_vModelCheckbox, isUnknownActive.value]
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("img", {
          src: _imports_6,
          class: "icon mb-1 me-3"
        }, null, -1)),
        _cache[21] || (_cache[21] = _createElementVNode("label", {
          class: "form-check-label NKT-P2",
          for: "flexCheckUnknown"
        }, " Unknown ", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input me-3",
          type: "checkbox",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isOtherActive).value = $event)),
          id: "flexCheckOther"
        }, null, 512), [
          [_vModelCheckbox, isOtherActive.value]
        ]),
        _cache[22] || (_cache[22] = _createElementVNode("img", {
          src: _imports_7,
          class: "icon mb-1 me-3"
        }, null, -1)),
        _cache[23] || (_cache[23] = _createElementVNode("label", {
          class: "form-check-label NKT-P2",
          for: "flexCheckOther"
        }, " Other ", -1))
      ])
    ])
  ], 8, _hoisted_1))
}
}

})